import { ThemeProvider } from '@mui/material/styles';
import { RoutalTheme } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { RawIntlProvider } from 'react-intl';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import * as routing from '../constants/Routing';
import { intl, setSelectedIntl } from '../helpers/IntGlobalProvider';
import { languageShort } from '../helpers/Translations';
import { APIDocs } from './APIDocs';
// import APIDocsV1 from './APIDocsV1';
import { Landing } from './Landing';

let { language } = navigator; // language without region code

switch (languageShort(language)) {
  case `eu`:
  case `es`:
  case `gl`:
  case `ca`:
    language = `es-es`;
    break;
  default:
    language = `en-us`;
}

const DevelopersContent = () => {
  const [defaultIntl, setDefaultIntl] = useState(intl);

  useEffect(() => {
    // Setting the user language.
    const locale = languageShort(language);
    setSelectedIntl(locale);
    setDefaultIntl(intl);
  }, []);

  return (
    <ThemeProvider theme={RoutalTheme}>
      <RawIntlProvider value={defaultIntl}>
        <Router>
          <Routes>
            <Route path={routing.ROOT} element={<Landing />} />
            <Route path={routing.APIv2} element={<APIDocs />} />
            <Route path="/" element={<Navigate to={routing.ROOT} />} />
          </Routes>
        </Router>
      </RawIntlProvider>
    </ThemeProvider>
  );
};

export default DevelopersContent;
